import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactForm.css';

const ContactForm = ({ buttonText = 'CONTACT US', placeholderMessage = 'Message...' }) => {
  const form = useRef();
  const [status, setStatus] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_bfoyci9',
      'template_k0wysuw',    // Replace with your actual template ID
      form.current,
      '-sTygXJtYyIg_aBFe' 
    )
    .then(
      () => {
        setStatus('Message sent successfully!');
        form.current.reset(); 
      },
      (error) => {
        setStatus('Failed to send message. Please try again.');
        console.error(error);
      }
    );
  };

  return (
    <form ref={form} onSubmit={sendEmail} className="contact-form">
      <input type="text" name="user_name" placeholder="Full Name" className="form-input" required />
      <input type="email" name="user_email" placeholder="Email Address" className="form-input" required />
      <input type="tel" name="user_phone" placeholder="Phone No." className="form-input" />
      <textarea name="message" placeholder={placeholderMessage} className="form-textarea" required></textarea>
      <button type="submit" className="form-button">{buttonText}</button>
      {status && <p className="form-status">{status}</p>}
    </form>
  );
};

export default ContactForm;
